import { useCallback } from 'react';

import type { ShareActionsOptions, ShareChannel } from 'src/app/shared/hooks/share';

import { useAutoCheckOffTask } from '../../../../useAutoCheckOffTask';

export function useOnDashboardShareSuccess(): NonNullable<ShareActionsOptions<ShareChannel>['onSuccess']> {
	const autoCheckOffTask = useAutoCheckOffTask();
	return useCallback(() => {
		void autoCheckOffTask('share_friends');
	}, [autoCheckOffTask]);
}
